<!-- ===================== HERO / BANNER ===================== -->
<section class="rs-hero" #rsHero aria-labelledby="rs-hero-title">
  <!-- decorative layers -->
  <div class="rs-hero__deco" aria-hidden="true">
    <span class="rs-hero__blob rs-hero__blob--1"></span>
    <span class="rs-hero__blob rs-hero__blob--2"></span>
    <span class="rs-hero__blob rs-hero__blob--3"></span>
    <span class="rs-hero__dots rs-hero__dots--1"></span>
    <span class="rs-hero__dots rs-hero__dots--2"></span>
    <span class="rs-hero__ring rs-hero__ring--1"></span>
    <span class="rs-hero__ring rs-hero__ring--2"></span>
  </div>

  <div class="container rs-hero__inner">
    <!-- ---------- left: copy ---------- -->
    <div class="rs-hero__copy">
      <span class="rs-badge">
        <svg class="rs-badge__spark" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M12 2.5l1.9 5.6 5.6 1.9-5.6 1.9L12 17.5l-1.9-5.6L4.5 10l5.6-1.9L12 2.5z" />
        </svg>
        We Turn Ideas Into Powerful Digital Experiences
      </span>

      <h1 class="rs-title" id="rs-hero-title">
        <span class="sr-only">We Build Smart Digital Solutions</span>
        <span
          class="rs-title__line"
          [class.rs-title__line--hero]="line.grad"
          *ngFor="let line of heroLines; let li = index"
          aria-hidden="true"
        >
          <span
            class="rs-title__mask"
            [class.rs-title__mask--grad]="line.grad"
            [style.--n]="line.n"
          >
            <span class="rs-title__word" *ngFor="let word of line.words">
              <span
                class="rs-title__char"
                *ngFor="let c of word.chars"
                [style.--i]="c.i"
                [style.--li]="li"
                >{{ c.ch }}</span
              >
            </span>
          </span>
        </span>
        <span class="rs-title__rule" aria-hidden="true"></span>
      </h1>

      <p class="rs-lede">
        We create high-performing websites, mobile apps, custom software, and
        digital marketing strategies that help your business grow, engage, and
        lead in the digital world.
      </p>

      <div class="rs-ctas">
        <button
          type="button"
          class="rs-btn rs-btn--primary"
          #rsMagnet
          (click)="rippleAndConsult($event)"
        >
          <span class="rs-btn__label">Let's Build Together</span>
          <span class="rs-btn__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
              <path d="M5 12h14M13 6l6 6-6 6" />
            </svg>
          </span>
        </button>

        <a
          class="rs-btn rs-btn--ghost"
          routerLink="/our-portfolio"
          #rsMagnet
          (click)="ripple($event)"
        >
          <span class="rs-btn__label">Explore Our Work</span>
          <span class="rs-btn__icon rs-btn__icon--play" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z" /></svg>
          </span>
        </a>
      </div>
    </div>

    <!-- ---------- right: blob visual ---------- -->
    <div class="rs-hero__visual" aria-hidden="true">
      <!-- paper plane on a dashed flight path -->
      <svg class="rs-plane" viewBox="0 0 220 300" fill="none">
        <path
          class="rs-plane__path"
          d="M18 22 C 60 90, 40 190, 96 262"
          stroke="url(#planeGrad)"
          stroke-width="1.6"
          stroke-dasharray="5 7"
          stroke-linecap="round"
        />
        <defs>
          <linearGradient id="planeGrad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stop-color="#ff2d95" stop-opacity=".9" />
            <stop offset="100%" stop-color="#b14eff" stop-opacity="0" />
          </linearGradient>
        </defs>
        <g class="rs-plane__icon">
          <path
            d="M2 12 L26 2 L16 26 L13 15 Z"
            fill="none"
            stroke="#ff2d95"
            stroke-width="1.8"
            stroke-linejoin="round"
          />
        </g>
      </svg>

      <div class="rs-heroMedia">
        <div class="rs-heroMedia__shape">
          <video
            class="rs-heroMedia__video"
            #rsVideo
            autoplay
            muted
            loop
            playsinline
            preload="auto"
            disablepictureinpicture
          >
            <source src="assets/banner_video.mp4" type="video/mp4" />
          </video>
          <span class="rs-heroMedia__tint"></span>
        </div>
      </div>

      <span class="rs-pill rs-pill--1">Innovate<br />Create<br />Elevate</span>
      <span class="rs-pill rs-pill--2">Let's<br />Build<br />Future</span>
    </div>
  </div>

  <!-- ---------- stats ----------
       Bound to the same counters the Work Counter section uses; #myDOMElement
       moved here so the count-up starts from the hero rather than mid-page. -->
  <div class="container rs-hero__statsWrap">
    <ul class="rs-stats" #myDOMElement>
      <li class="rs-stat" style="--i: 0; --tone: var(--rs-pink)">
        <span class="rs-stat__top">
          <span class="rs-stat__ico">
            <img loading="lazy" src="assets/images/served.webp" alt="served" width="34" height="34" />
          </span>
          <span class="rs-stat__meta">
            <span class="rs-stat__value">{{ conties }}<em>+</em></span>
            <span class="rs-stat__label">Countries Served</span>
          </span>
        </span>
        <span class="rs-stat__desc">
          We have worked with clients from 20+ countries worldwide.
        </span>
      </li>

      <li class="rs-stat" style="--i: 1; --tone: var(--rs-purple)">
        <span class="rs-stat__top">
          <span class="rs-stat__ico">
            <img loading="lazy" src="assets/images/projects.webp" alt="projects" width="34" height="34" />
          </span>
          <span class="rs-stat__meta">
            <span class="rs-stat__value">{{ pojectcomplete }}<em>+</em></span>
            <span class="rs-stat__label">Project Completed</span>
          </span>
        </span>
        <span class="rs-stat__desc">
          Successfully delivered 200+ projects across industries.
        </span>
      </li>

      <li class="rs-stat" style="--i: 2; --tone: var(--rs-indigo)">
        <span class="rs-stat__top">
          <span class="rs-stat__ico">
            <img loading="lazy" src="assets/images/experts.webp" alt="experts" width="34" height="34" />
          </span>
          <span class="rs-stat__meta">
            <span class="rs-stat__value">{{ projectexpert }}<em>+</em></span>
            <span class="rs-stat__label">Project Experts</span>
          </span>
        </span>
        <span class="rs-stat__desc">
          Our team of 25+ experts builds amazing digital solutions.
        </span>
      </li>

      <li class="rs-stat" style="--i: 3; --tone: var(--rs-blue)">
        <span class="rs-stat__top">
          <span class="rs-stat__ico">
            <img loading="lazy" src="assets/images/groth.webp" alt="groth" width="34" height="34" />
          </span>
          <span class="rs-stat__meta">
            <span class="rs-stat__value">{{ marketing }}<em>+</em></span>
            <span class="rs-stat__label">Market Experience</span>
          </span>
        </span>
        <span class="rs-stat__desc">
          10+ years of experience delivering value and driving growth.
        </span>
      </li>
    </ul>
  </div>
</section>
<!-- =================== END HERO / BANNER =================== -->

<!-- -------------------------Banner Section Start----------------- -->

<!-- -------------------------Services Section Start----------------- -->
<app-services></app-services>
<!-- -------------------------Services Section End----------------- -->

<!-- -------------------------Our Technologies Section Start----------------- -->

<app-ecosystem></app-ecosystem>

<!-- -------------------------Our Technologies Section End----------------- -->

<!-- -------------------------Work Counter Section Start----------------- -->

<section class="rs-commit" id="commitment" #rsCommit>
  <!-- decorative layers -->
  <div class="rs-commit__deco" aria-hidden="true">
    <span class="rs-commit__blob rs-commit__blob--1"></span>
    <span class="rs-commit__blob rs-commit__blob--2"></span>
    <span class="rs-commit__dots rs-commit__dots--1"></span>
    <span class="rs-commit__dots rs-commit__dots--2"></span>
    <span class="rs-commit__ring"></span>
    <span class="rs-commit__line"></span>
  </div>

  <div class="container rs-commit__inner">
    <!-- ---------- stat cards ---------- -->
    <ul class="rs-cstats">
      <li
        class="rs-cstat"
        *ngFor="let stat of commitStats; let i = index"
        [style.--i]="i"
        [style.--tone]="stat.tone"
      >
        <span class="rs-cstat__ico" [innerHTML]="stat.icon"></span>
        <span class="rs-cstat__num">{{ stat.value }}<em>+</em></span>
        <span class="rs-cstat__label">{{ stat.label }}</span>
        <span class="rs-cstat__rule" aria-hidden="true"></span>
        <span class="rs-cstat__dots" aria-hidden="true"></span>
      </li>
    </ul>

    <!-- ---------- commitment panel ---------- -->
    <div class="rs-panel">
      <span class="rs-panel__overlay" aria-hidden="true"></span>

      <div class="rs-panel__grid">
        <!-- left: commitment -->
        <div class="rs-panel__left">
          <span class="rs-panel__eyebrow">
            <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M12 2.5l1.9 5.6 5.6 1.9-5.6 1.9L12 17.5l-1.9-5.6L4.5 10l5.6-1.9L12 2.5z" />
            </svg>
            Our Commitment
          </span>

          <h3 class="rs-panel__title">
            We’re Committed To Deliver High
            <span class="rs-panel__title-grad">Quality</span> Projects.
          </h3>

          <span class="rs-panel__rule" aria-hidden="true"></span>

          <ul class="rs-feats">
            <li
              class="rs-feat"
              *ngFor="let f of commitFeatures; let i = index"
              [style.--i]="i"
            >
              <span class="rs-feat__ico" [innerHTML]="f.icon"></span>
              <span class="rs-feat__title">{{ f.title }}</span>
              <span class="rs-feat__sub">{{ f.sub }}</span>
            </li>
          </ul>
        </div>

        <!-- right: trusted card -->
        <div class="rs-panel__right">
          <div class="rs-trust">
            <span class="rs-trust__quote" aria-hidden="true">&ldquo;</span>
            <span class="rs-trust__dots" aria-hidden="true"></span>

            <h4 class="rs-trust__title">
              We’re trusted by more than
              <span class="rs-trust__title-grad">100 clients</span>
            </h4>
            <span class="rs-trust__rule" aria-hidden="true"></span>

            <p class="rs-trust__text">
              Our sole aim is to make you get recognition in the online market.
              Evolving your business to a newer height is our business. With our
              years of experience, we give the word of honour to provide you the
              best of the services by our savvy people.
            </p>

            <div class="rs-trust__cta Consult_btn">
              <app-consult-now-modal id="welcomedialog"></app-consult-now-modal>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- -------------------------Work Counter Section End----------------- -->

<app-ai-solutions></app-ai-solutions>

<!-- -------------------------Industries Section Start----------------- -->

<section class="rs-ind" id="industries" #rsInd>
  <!-- decorative layers -->
  <div class="rs-ind__deco" aria-hidden="true">
    <span class="rs-ind__blob rs-ind__blob--1"></span>
    <span class="rs-ind__blob rs-ind__blob--2"></span>
    <span class="rs-ind__dots rs-ind__dots--1"></span>
    <span class="rs-ind__dots rs-ind__dots--2"></span>
    <span class="rs-ind__ring"></span>
    <span class="rs-ind__wave"></span>
    <span class="rs-ind__spark" style="--sx: 12%; --sy: 20%; --sd: 0s"></span>
    <span class="rs-ind__spark" style="--sx: 88%; --sy: 14%; --sd: 1.3s"></span>
    <span class="rs-ind__spark" style="--sx: 72%; --sy: 82%; --sd: 0.7s"></span>
  </div>

  <div class="container rs-ind__inner">
    <div class="rs-ind__head">
      <span class="rs-ind__eyebrow">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M4 21V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v16" /><path d="M14 9h4a2 2 0 0 1 2 2v10" /><path d="M2 21h20" /><path d="M7.5 7h2M7.5 11h2M7.5 15h2" />
        </svg>
        Industries We Serve
      </span>

      <h2 class="rs-ind__title">
        Industries <span class="rs-ind__title-grad">We Serve</span>
      </h2>

      <span class="rs-ind__divider" aria-hidden="true">
        <i></i><i></i><i></i><i></i><i></i>
      </span>

      <p class="rs-ind__lede">
        We empower businesses across multiple industries with scalable, secure,
        and innovative digital solutions tailored to their unique needs.
      </p>
    </div>

    <!-- ---------- industry cards ---------- -->
    <ul class="rs-ind__grid">
      <li
        class="rs-icard"
        *ngFor="let ind of industries; let i = index"
        [style.--i]="i"
        [style.--ia]="ind.a"
        [style.--ib]="ind.b"
      >
        <figure class="rs-icard__media">
          <img loading="lazy" [src]="ind.img" [alt]="ind.name" />
          <span class="rs-icard__tint" aria-hidden="true"></span>
          <span class="rs-icard__shine" aria-hidden="true"></span>
        </figure>

        <span class="rs-icard__badge" aria-hidden="true">
          <span class="rs-icard__badge-ico" [innerHTML]="ind.icon"></span>
        </span>

        <h3 class="rs-icard__name">{{ ind.name }}</h3>
        <span class="rs-icard__rule" aria-hidden="true"></span>
      </li>
    </ul>
  </div>
</section>

<!-- -------------------------Industries Section End----------------- -->

<!-- -------------------------Form Parallax Section Start----------------- -->

<section class="rs-cta" id="contact-cta" #rsCta>
  <!-- team photo + directional scrims -->
  <div class="rs-cta__media" aria-hidden="true">
    <img
      class="rs-cta__photo"
      src="https://images.prismic.io/kurmishadi/38fd26f5-cef4-47c4-9ca7-dd8d73ab2730__%281%29.png?auto=compress,format"
      alt=""
      loading="lazy"
      decoding="async"
    />
    <span class="rs-cta__scrim"></span>
    <span class="rs-cta__blob rs-cta__blob--1"></span>
    <span class="rs-cta__blob rs-cta__blob--2"></span>
    <span class="rs-cta__dots rs-cta__dots--1"></span>
    <span class="rs-cta__dots rs-cta__dots--2"></span>
    <span class="rs-cta__spark" style="--sx: 12%; --sy: 24%; --sd: 0s"></span>
    <span class="rs-cta__spark" style="--sx: 38%; --sy: 12%; --sd: 1.2s"></span>
    <span class="rs-cta__spark" style="--sx: 55%; --sy: 78%; --sd: 2.1s"></span>
    <span class="rs-cta__spark" style="--sx: 82%; --sy: 18%; --sd: 0.6s"></span>
    <span class="rs-cta__spark" style="--sx: 90%; --sy: 62%; --sd: 1.7s"></span>
    <span class="rs-cta__line rs-cta__line--1"></span>
    <span class="rs-cta__line rs-cta__line--2"></span>
    <span class="rs-cta__wave"></span>
  </div>

  <div class="container rs-cta__inner">
    <div class="rs-cta__grid">
      <!-- ---------- left: copy ---------- -->
      <div class="rs-cta__copy">
        <span class="rs-cta__eyebrow">
          Let&rsquo;s Build Something Amazing
          <i aria-hidden="true"></i>
        </span>

        <h2 class="rs-cta__title">
          <span class="rs-cta__tline" style="--l: 0">Great Things In Business</span>
          <span class="rs-cta__tline" style="--l: 1">Are Never Done By</span>
          <span class="rs-cta__tline" style="--l: 2">One Person.</span>
          <span class="rs-cta__tline" style="--l: 3">They&rsquo;re Done By A</span>
          <span class="rs-cta__tline rs-cta__tline--grad" style="--l: 4">Team Of Experts.</span>
        </h2>

        <p class="rs-cta__lede">
          We combine creativity, technology, and teamwork to deliver exceptional
          solutions that drive real results.
        </p>

        <ul class="rs-cta__feats">
          <li class="rs-cta__feat" style="--i: 0">
            <span class="rs-cta__feat-ico" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 12a8 8 0 0 1 16 0" /><path d="M3 14a2 2 0 0 1 2-2h1v6H5a2 2 0 0 1-2-2z" /><path d="M21 14a2 2 0 0 0-2-2h-1v6h1a2 2 0 0 0 2-2z" /><path d="M19 18a3 3 0 0 1-3 3h-2" />
              </svg>
            </span>
            <span class="rs-cta__feat-tx">
              <strong>Free Consultation</strong>
              <small>Discuss your idea with our experts</small>
            </span>
          </li>
          <li class="rs-cta__feat" style="--i: 1">
            <span class="rs-cta__feat-ico" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
                <path d="M13 2 4.5 13.5H11L10 22l8.5-11.5H12z" />
              </svg>
            </span>
            <span class="rs-cta__feat-tx">
              <strong>Fast Response</strong>
              <small>We reply within one business day</small>
            </span>
          </li>
          <li class="rs-cta__feat" style="--i: 2">
            <span class="rs-cta__feat-ico" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
            </span>
            <span class="rs-cta__feat-tx">
              <strong>Dedicated Team</strong>
              <small>A dedicated team for your project</small>
            </span>
          </li>
        </ul>
      </div>

      <!-- ---------- right: glass form ---------- -->
      <div class="rs-cta__panel">
        <span class="rs-cta__orb" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="currentColor"><path d="M21.4 2.6a1 1 0 0 0-1.06-.23l-17 6.5a1 1 0 0 0 .06 1.88l7.2 2.25 2.25 7.2a1 1 0 0 0 1.88.06l6.5-17a1 1 0 0 0-.23-1.06zM11.1 12.9 5.6 11.2l11.83-4.52L12.9 12.9z" /></svg>
        </span>

        <div class="rs-cta__form">
          <h4 class="rs-cta__form-title">
            Let&rsquo;s Get Your <span>Project</span> Started!
          </h4>

          <form [formGroup]="formData" class="rs-cta__fields">
            <div class="rs-field">
              <span class="rs-field__ico" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>
              </span>
              <input
                type="text"
                class="rs-field__input"
                placeholder="Your Name"
                required
                formControlName="Name"
                (keypress)="noSpace($event)"
              />
              <div id="formError" *ngIf="fullName && fullName.invalid && fullName.touched">
                <span *ngIf="fullName.errors?.['required']">Required</span>
                <span *ngIf="fullName.errors?.['pattern'] && !fullName.errors?.['required']">Invalid Name input</span>
              </div>
            </div>

            <div class="rs-field">
              <span class="rs-field__ico" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="2.5" y="4.5" width="19" height="15" rx="2.5" /><path d="m3 7 9 6 9-6" /></svg>
              </span>
              <input
                type="text"
                class="rs-field__input"
                placeholder="Email Address"
                required
                formControlName="Email"
              />
              <div id="formError" *ngIf="email && email.invalid && email.touched">
                <span *ngIf="email.errors?.['required']">Required</span>
                <span *ngIf="email.errors?.['pattern'] && !email.errors?.['required']">Invalid email</span>
              </div>
            </div>

            <div class="rs-field">
              <span class="rs-field__ico" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M5 3.5h4l1.5 4.5-2.5 1.5a12 12 0 0 0 6 6l1.5-2.5 4.5 1.5v4a2 2 0 0 1-2.18 2A17.5 17.5 0 0 1 3 5.68 2 2 0 0 1 5 3.5z" /></svg>
              </span>
              <input
                type="text"
                (keypress)="numberOnly($event)"
                class="rs-field__input"
                placeholder="Phone Number"
                required
                formControlName="Number"
                maxlength="10"
              />
              <div id="formError" *ngIf="contact && contact.invalid && contact.touched">
                <span *ngIf="contact.errors?.['required']">Required</span>
                <span *ngIf="contact.errors?.['pattern'] && !contact.errors?.['required']">Invalid input</span>
              </div>
            </div>

            <div class="rs-field">
              <span class="rs-field__ico" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M20.6 13.4 12 22H2v-10l8.6-8.6a2 2 0 0 1 2.8 0l7.2 7.2a2 2 0 0 1 0 2.8z" transform="scale(-1,1) translate(-24,0)" /><circle cx="8.5" cy="8.5" r="1.4" /></svg>
              </span>
              <input
                type="text"
                class="rs-field__input"
                placeholder="Subject"
                required
                formControlName="Subject"
                (keypress)="noSpace($event)"
              />
              <div id="formError" *ngIf="sub && sub.invalid && sub.touched">
                <span *ngIf="sub.errors?.['required']">Required</span>
              </div>
            </div>

            <div class="rs-field rs-field--full">
              <span class="rs-field__ico" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9" /><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z" /></svg>
              </span>
              <textarea
                name="message"
                class="rs-field__input rs-field__area"
                placeholder="Write Message"
                required
                formControlName="msg"
                (keypress)="noSpace($event)"
              ></textarea>
              <div id="formError" *ngIf="msg && msg.invalid && msg.touched">
                <span *ngIf="msg.errors?.['required']">Required</span>
                <span *ngIf="msg.errors?.['minlength'] && !msg.errors?.['pattern']">Minimum 10 Words are Required</span>
              </div>
            </div>

            <button
              type="button"
              (click)="submit()"
              [disabled]="formData.invalid"
              class="rs-cta__send"
            >
              <span class="rs-cta__send-shine" aria-hidden="true"></span>
              Send Message
              <span class="rs-cta__send-arrow" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M21.4 2.6a1 1 0 0 0-1.06-.23l-17 6.5a1 1 0 0 0 .06 1.88l7.2 2.25 2.25 7.2a1 1 0 0 0 1.88.06l6.5-17a1 1 0 0 0-.23-1.06zM11.1 12.9 5.6 11.2l11.83-4.52L12.9 12.9z" /></svg>
              </span>
            </button>

            <p class="rs-cta__secure">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4.5" y="10.5" width="15" height="10" rx="2" /><path d="M8 10.5V7a4 4 0 0 1 8 0v3.5" /></svg>
              Your information is secure and will never be shared.
            </p>
          </form>
        </div>
      </div>
    </div>

    <!-- ---------- value cards ---------- -->
    <ul class="rs-cta__cards">
      <li class="rs-vcard" style="--i: 0; --tone: #ff2d95">
        <span class="rs-vcard__ico" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12a8 8 0 0 1 16 0" /><path d="M3 14a2 2 0 0 1 2-2h1v6H5a2 2 0 0 1-2-2z" /><path d="M21 14a2 2 0 0 0-2-2h-1v6h1a2 2 0 0 0 2-2z" /><path d="M19 18a3 3 0 0 1-3 3h-2" /></svg>
        </span>
        <span class="rs-vcard__tx">
          <strong>Free Consultation</strong>
          <small>Discuss your idea with our experts before making any commitment.</small>
        </span>
        <i class="rs-vcard__tick" aria-hidden="true"></i>
      </li>
      <li class="rs-vcard" style="--i: 1; --tone: #b14eff">
        <span class="rs-vcard__ico" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2 4.5 13.5H11L10 22l8.5-11.5H12z" /></svg>
        </span>
        <span class="rs-vcard__tx">
          <strong>Quick Response</strong>
          <small>We usually respond to all business inquiries within one business day.</small>
        </span>
        <i class="rs-vcard__tick" aria-hidden="true"></i>
      </li>
      <li class="rs-vcard" style="--i: 2; --tone: #6c63ff">
        <span class="rs-vcard__ico" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" /><path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" /><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" /><path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" /></svg>
        </span>
        <span class="rs-vcard__tx">
          <strong>End-to-End Development</strong>
          <small>From strategy and design to development, deployment, and long-term support.</small>
        </span>
        <i class="rs-vcard__tick" aria-hidden="true"></i>
      </li>
    </ul>
  </div>
</section>

<!-- -------------------------Form Parallax Section End----------------- -->

<!-- -------------------------Global Partners Section Start----------------- -->

<section class="rs-globe" id="global-partners" #rsGlobe>
  <!-- decorative layers -->
  <div class="rs-globe__deco" aria-hidden="true">
    <span class="rs-globe__blob rs-globe__blob--1"></span>
    <span class="rs-globe__blob rs-globe__blob--2"></span>
    <span class="rs-globe__dots rs-globe__dots--1"></span>
    <span class="rs-globe__dots rs-globe__dots--2"></span>
    <span class="rs-globe__wave rs-globe__wave--1"></span>
    <span class="rs-globe__wave rs-globe__wave--2"></span>
  </div>

  <div class="container rs-globe__inner">
    <div class="rs-globe__head">
      <span class="rs-globe__eyebrow">Global Presence</span>
      <h2 class="rs-globe__title">
        Business Partners
        <span class="rs-globe__title-grad">Around The World</span>
      </h2>
      <p class="rs-globe__lede">
        We collaborate with clients and partners from different countries to
        deliver innovative digital solutions that create real impact.
      </p>
    </div>

    <div class="rs-globe__layout">
      <!-- ---------- map stage ---------- -->
      <div class="rs-globe__stage" aria-label="Map of ResilienceSoft client countries">
        <svg class="rs-globe__map" viewBox="0 0 1000 520" fill="none" preserveAspectRatio="xMidYMid meet" aria-hidden="true">
          <defs>
            <pattern id="rsDots" width="9" height="9" patternUnits="userSpaceOnUse">
              <circle cx="2" cy="2" r="1.55" fill="rgba(124, 97, 255, 0.30)" />
            </pattern>
            <linearGradient id="rsGlobeGrad" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stop-color="#ff2d95" />
              <stop offset="50%" stop-color="#b14eff" />
              <stop offset="100%" stop-color="#3b82f6" />
            </linearGradient>
          </defs>

          <!-- abstract dotted continents -->
          <g class="rs-globe__land">
            <path d="M60 92 C140 55 235 70 262 110 C300 122 302 168 272 184 C242 228 190 234 150 214 C92 224 46 174 60 130 Z" fill="url(#rsDots)" />
            <path d="M226 232 C246 248 256 274 246 292 C230 282 219 254 218 240 Z" fill="url(#rsDots)" />
            <path d="M330 56 C360 44 386 60 376 86 C356 96 330 86 330 56 Z" fill="url(#rsDots)" />
            <path d="M272 300 C310 284 346 300 346 346 C351 400 326 456 301 470 C286 445 271 396 266 350 C261 325 263 310 272 300 Z" fill="url(#rsDots)" />
            <path d="M436 122 C476 100 540 104 560 124 C572 144 556 164 541 170 C520 185 478 186 462 176 C444 162 428 136 436 122 Z" fill="url(#rsDots)" />
            <path d="M470 212 C510 190 560 196 586 226 C601 260 591 310 571 350 C556 394 531 420 516 414 C496 394 481 340 471 300 C463 260 461 232 470 212 Z" fill="url(#rsDots)" />
            <path d="M580 96 C650 60 760 66 830 96 C900 120 921 170 891 200 C861 240 801 254 761 245 C731 270 691 274 666 255 C636 260 601 240 591 210 C571 170 561 122 580 96 Z" fill="url(#rsDots)" />
            <path d="M648 240 C680 234 701 256 691 290 C676 316 656 300 650 272 Z" fill="url(#rsDots)" />
            <path d="M772 290 C796 284 816 300 811 320 C791 330 771 316 772 290 Z" fill="url(#rsDots)" />
            <path d="M812 382 C851 365 896 380 906 410 C911 440 881 460 846 455 C816 450 796 416 812 382 Z" fill="url(#rsDots)" />
          </g>

          <!-- connections + travelling sparks -->
          <g class="rs-globe__lines">
            <path
              *ngFor="let c of globeCountries; let i = index"
              class="rs-globe__line"
              [class.is-hot]="hotGlobe === i"
              [attr.d]="c.line"
              stroke="url(#rsGlobeGrad)"
            />
            <circle
              class="rs-globe__spark"
              r="3"
              *ngFor="let c of globeCountries; let i = index"
            >
              <animateMotion
                [attr.path]="c.line"
                [attr.begin]="-i * 0.45 + 's'"
                dur="3.6s"
                repeatCount="indefinite"
              />
            </circle>
          </g>
        </svg>

        <!-- headquarters -->
        <div class="rs-hq" style="left: 67%; top: 50%">
          <span class="rs-hq__ring" aria-hidden="true"></span>
          <span class="rs-hq__core">R</span>
          <span class="rs-hq__label">
            <strong>ResilienceSoft</strong>
            <small>India</small>
          </span>
        </div>

        <!-- country pins -->
        <div
          class="rs-pin"
          *ngFor="let c of globeCountries; let i = index"
          [style.left.%]="c.x"
          [style.top.%]="c.y"
          [style.--i]="i"
          [attr.data-side]="c.card"
          (mouseenter)="hotGlobe = i"
          (mouseleave)="hotGlobe = -1"
        >
          <span class="rs-pin__dot" aria-hidden="true"><i></i></span>

          <a class="rs-pin__card" *ngIf="c.card !== 'none'" tabindex="0">
            <img [src]="c.flag" [alt]="c.name + ' flag'" width="28" height="19" loading="lazy" />
            <span class="rs-pin__meta">
              <strong>{{ c.name }}</strong>
              <small>Partner since {{ c.since }}</small>
            </span>
          </a>

          <span class="rs-pin__tip" *ngIf="c.card === 'none'" role="tooltip">
            <img [src]="c.flag" [alt]="''" width="24" height="16" loading="lazy" />
            <span class="rs-pin__meta">
              <strong>{{ c.name }}</strong>
              <small>Partner since {{ c.since }}</small>
            </span>
          </span>
        </div>
      </div>

      <!-- ---------- floating stats panel ---------- -->
      <aside class="rs-globe__panel">
        <h3 class="rs-globe__panel-title">Our Global Presence</h3>
        <ul class="rs-gstats">
          <li
            class="rs-gstat"
            *ngFor="let g of globeStats; let i = index"
            [style.--i]="i"
            [style.--tone]="g.tone"
          >
            <span class="rs-gstat__ico" [innerHTML]="g.icon"></span>
            <span class="rs-gstat__meta">
              <strong>{{ g.value }}{{ g.suffix }}</strong>
              <small>{{ g.label }}</small>
            </span>
          </li>
        </ul>
      </aside>
    </div>

    <!-- mobile country list (map cards hide on small screens) -->
    <ul class="rs-globe__list" aria-label="Client countries">
      <li *ngFor="let c of globeCountries">
        <img [src]="c.flag" [alt]="''" width="26" height="17" loading="lazy" />
        <span class="rs-pin__meta">
          <strong>{{ c.name }}</strong>
          <small>Partner since {{ c.since }}</small>
        </span>
      </li>
    </ul>

    <!-- ---------- bottom statistics bar ---------- -->
    <ul class="rs-gbar">
      <li
        class="rs-gbar__cell"
        *ngFor="let g of globeStats; let i = index"
        [style.--i]="i"
        [style.--tone]="g.tone"
      >
        <span class="rs-gstat__ico" [innerHTML]="g.icon"></span>
        <span class="rs-gstat__meta">
          <strong>{{ g.value }}{{ g.suffix }}</strong>
          <small>{{ g.label }}</small>
        </span>
      </li>
    </ul>
  </div>
</section>

<!-- -------------------------Global Partners Section End----------------- -->

<!-- -------------------------Office Team Section Start----------------- -->

<section class="rs-team" id="team" #rsTeam>
  <!-- decorative layers -->
  <div class="rs-team__deco" aria-hidden="true">
    <span class="rs-team__blob rs-team__blob--1"></span>
    <span class="rs-team__blob rs-team__blob--2"></span>
    <span class="rs-team__dots rs-team__dots--1"></span>
    <span class="rs-team__dots rs-team__dots--2"></span>
    <span class="rs-team__ring"></span>
    <span class="rs-team__wave"></span>
  </div>

  <div class="container rs-team__inner">
    <div class="rs-team__head">
      <span class="rs-team__eyebrow">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
        Our Team
      </span>

      <h2 class="rs-team__title">
        Meet The <span class="rs-team__title-grad">Expert Team</span>
      </h2>

      <span class="rs-team__divider" aria-hidden="true"><i></i><em></em></span>

      <p class="rs-team__lede">
        Our talented team combines creativity, innovation, and technical
        expertise to build world-class digital solutions for businesses
        worldwide.
      </p>

      <!-- feature bar -->
      <ul class="rs-team__feats">
        <li
          class="rs-team__feat"
          *ngFor="let f of teamFeats; let i = index"
          [style.--i]="i"
        >
          <span class="rs-team__feat-ico" [innerHTML]="f.icon"></span>
          <span class="rs-team__feat-label">{{ f.label }}</span>
        </li>
      </ul>
    </div>

    <!-- ---------- team grid ---------- -->
    <ul class="rs-team__grid">
      <li
        class="rs-member"
        *ngFor="let m of teamMembers; let i = index"
        [style.--i]="i"
        [style.--tone]="m.tone"
      >
        <span class="rs-member__shine" aria-hidden="true"></span>
        <span class="rs-member__halo" aria-hidden="true"></span>

        <span class="rs-member__photo">
          <span class="rs-member__photo-ring" aria-hidden="true"></span>
          <img loading="lazy" [src]="m.img" [alt]="m.name" />
        </span>

        <h3 class="rs-member__name">{{ m.name }}</h3>
        <span class="rs-member__role">{{ m.role }}</span>
        <span class="rs-member__rule" aria-hidden="true"></span>
        <p class="rs-member__desc">{{ m.desc }}</p>
        <span class="rs-member__dept">{{ m.dept }}</span>
      </li>
    </ul>

    
  </div>
</section>

<!-- -------------------------Office Team Section End----------------- -->

<!-- -------------------------Client Feedbacks Section Start----------------- -->

<section class="rs-testi" id="testimonials" #rsTesti>
  <!-- decorative layers -->
  <div class="rs-testi__deco" aria-hidden="true">
    <span class="rs-testi__blob rs-testi__blob--1"></span>
    <span class="rs-testi__blob rs-testi__blob--2"></span>
    <span class="rs-testi__dots rs-testi__dots--1"></span>
    <span class="rs-testi__dots rs-testi__dots--2"></span>
    <span class="rs-testi__ring"></span>
    <span class="rs-testi__wave"></span>
  </div>

  <div class="container rs-testi__inner">
    <div class="rs-testi__head">
      <span class="rs-testi__eyebrow">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M19.8 5.6a5 5 0 0 0-7.1 0L12 6.3l-.7-.7a5 5 0 1 0-7.1 7.1l.7.7 7.1 7 7.1-7 .7-.7a5 5 0 0 0 0-7.1z" />
        </svg>
        Client Testimonials
      </span>

      <h2 class="rs-testi__title">
        What Our <span class="rs-testi__title-grad">Clients Say</span>
      </h2>

      <span class="rs-testi__divider" aria-hidden="true"><i></i><em></em></span>

      <p class="rs-testi__lede">
        We build long-term partnerships by delivering exceptional digital
        experiences and measurable business results.
      </p>
    </div>

    <!-- ---------- carousel ---------- -->
    <div class="rs-testi__stage">
      <button
        type="button"
        class="rs-testi__nav rs-testi__nav--prev"
        (click)="testiSlick.slickPrev()"
        aria-label="Previous testimonials"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m15 6-6 6 6 6" /></svg>
      </button>

      <ngx-slick-carousel
        class="rs-testi__slider"
        #testiSlick="slick-carousel"
        [config]="testiConfig"
      >
        <div ngxSlickItem *ngFor="let t of testimonials" class="rs-testi__slide">
          <article class="rs-tcard" [style.--tone]="t.tone">
            <span class="rs-tcard__shine" aria-hidden="true"></span>

            <span class="rs-tcard__quote" aria-hidden="true">
              <i class="fa fa-quote-left"></i>
            </span>

            <span class="rs-tcard__stars" aria-label="Rated 5 out of 5">
              <svg *ngFor="let s of [1, 2, 3, 4, 5]" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="m12 2.6 2.8 5.9 6.4.8-4.7 4.4 1.2 6.3L12 17l-5.7 3 1.2-6.3L2.8 9.3l6.4-.8z" /></svg>
            </span>

            <p class="rs-tcard__text">{{ t.text }}</p>

            <span class="rs-tcard__rule" aria-hidden="true"></span>

            <footer class="rs-tcard__who">
              <span class="rs-tcard__avatar" aria-hidden="true">{{ t.initials }}</span>
              <span class="rs-tcard__name">{{ t.name }}</span>
            </footer>
          </article>
        </div>
      </ngx-slick-carousel>

      <button
        type="button"
        class="rs-testi__nav rs-testi__nav--next"
        (click)="testiSlick.slickNext()"
        aria-label="Next testimonials"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m9 6 6 6-6 6" /></svg>
      </button>
    </div>

    <!-- ---------- trust bar ---------- -->
   
  </div>
</section>

<!-- -------------------------Client Feedbacks Section End----------------- -->
<!-- <section class="mediaPR">
  <p class="media-PR pb-5">MEDIA & PR</p>
  <a
    href="https://www.digitaljournal.com/pr/resiliencesoft-is-celebrating-its-10-years-anniversary-of-being-a-leader-in-the-it-industry"
    target="_blank"
  >
    <div class="card p-4 ads-card" style="width: 18rem">
      <img
        loading="lazy"
        class="card-img-top"
        src="../../assets/images/digital_journal.webp"
        alt="digital journal"
      /></div></a
  ><br />
</section> -->
